/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const RoamTransactionService = {
  /**
   * Get Screen data
   *
   * */
  async getByCode(url, filterByCode, select) {
    const requestScreenData = {
      url: "api/" + url,
      top: "1",
      filter: filterByCode,
      select: select
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },
  async saveTransaction(url, payload) {
    var seturl = "api/" + url;

    return await ApiService.post(seturl, payload);
  },

  async getDataSet(requestScreenData) {
    return await ApiService.oDataGet(requestScreenData);
  },

  async saveRoamTransaction(geturl, payload) {
    var url = "api/" + geturl;
    await ApiService.post(url, payload);
  },

  async deletePickingSlipStartTime(salesOrderCode) {     
    var url = "api/Save_PickingSlipStartTime";
    return await ApiService.delete(url, salesOrderCode, "Integer");
  },
};

export { RoamTransactionService };
